import * as TYPES from '../types'
import api from '../../api'
import moment from 'moment'

const state = {
  create: {
    step: 0,
    editing: {
      getClotheWay: 0,
      takeOffClotheWay: 0,
      planTakeAwayAt: moment().add(3, 'days').format('Y-M-D'),
      user: {
        profile: {
          name: '',
          phone: '',
          address: '',
          sex: ''
        }
      },
      clotheRecords: []
    },
    isSaving: false
  },
  list: {
    pageIndex: 1,
    pageSize: 20,
    totalCount: 0,
    totalPage: 0,
    items: []
  },
  view: {
    // 当前衣单
    body: {}, // 当前衣单JSON数据
    snaps: {
      // 为安全起见在衣单的每个重要阶段进行记录
      now: {}, // 当前的记录
      records: [] // 曾经的
    },
    imgUrl: '' // 用于分享衣单信息的图片地址
  },
  payment: {
    ticket: {
      user: {
        profile: {}
      }
    },
    fee: {}
  }
}

const mutations = {
  [TYPES.SET_CREATE_TICKET_STATE](state, data) {
    state.create.isSaving = data
  },
  [TYPES.RESET_CLOTHE_RECORDS](state) {
    state.create.editing.clotheRecords = []
  },
  [TYPES.ON_GET_TICKET_LIST](state, data) {
    state.list = data
  },
  [TYPES.ON_GET_TICKET](state, ticket) {
    state.payment.ticket = ticket
  },
  [TYPES.DO_ADD_CLOTHE_RECORD_TO_TICKET](state, clotheRecord) {
    state.create.editing.clotheRecords.push(clotheRecord)
  },
  [TYPES.DO_REMOVE_CLOTHE_RECORD_FROM_TICKET](state, records) {
    state.create.editing.clotheRecords = Object.assign([], records)
  }
}

const actions = {
  [TYPES.DO_GET_TICKET_LIST]({commit, state}) {
    return new Promise((resolve, reject) => {
      api.DO_GET_TICKET_LIST(state.list.pageIndex)
      .then(res => {
        commit(TYPES.ON_GET_TICKET_LIST, res.data.data)
        resolve(res)
      })
      .catch(res => {
        reject(res)
      })
    })
  },
  [TYPES.DO_CREATE_TICKET]({ commit }, ticket) {
    commit(TYPES.SET_CREATE_TICKET_STATE, true)
    let clotheRecords = ticket.clotheRecords.map(function (val, index, arr) {
      let flawRecords = val.flawRecords || []
      return {
        name: val.name,
        color: val.color.text,
        price: val.price,
        brand: val.brand.text,
        flawRecords: flawRecords.map(function (v, i, a) {
          return {
            text: v.text
          }
        })
      }
    })
    const data = {
      // userId: ticket.user.id,
      getClotheWay: ticket.getClotheWay,
      takeOffClotheWay: ticket.takeOffClotheWay,
      planTakeAwayAt: ticket.planTakeAwayAt,
      clotheRecords: clotheRecords
    }
    if (ticket.user.id) {
      console.log('id', ticket.user.id)
      data.userId = ticket.user.id
    } else {
      console.log('user', ticket.user)
      data.user = ticket.user
    }
    return new Promise(function (resolve, reject) {
      api
        .DO_CREATE_TICKET(data)
        .then(res => {
          if (res.data.ok) {
            commit(TYPES.RESET_CLOTHE_RECORDS)
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(res => {
          reject(res)
        })
        .finally(() => {
          commit(TYPES.SET_CREATE_TICKET_STATE, false)
        })
    })
  },
  [TYPES.DO_GET_TICKET]({ commit }, ticketID) {
    return new Promise(function (resolve, reject) {
      api
        .DO_GET_TICKET(ticketID)
        .then(res => {
          if (res.data.ok) {
            commit(TYPES.ON_GET_TICKET, res.data.data)
          } else {
            reject(res)
          }
        })
        .catch(res => {
          alert(res)
        })
    })
  },
  [TYPES.DO_ADD_CLOTHE_RECORD_TO_TICKET]({ commit }, clotheRecord) {
    return new Promise(function (resolve, reject) {
      commit(TYPES.DO_ADD_CLOTHE_RECORD_TO_TICKET, clotheRecord)
      resolve()
    })
  },
  [TYPES.DO_REMOVE_CLOTHE_RECORD_FROM_TICKET]({ commit, state }, clotheRecord) {
    return new Promise(function (resolve, reject) {
      let records = state.create.editing.clotheRecords
      records = records.filter(function (val, index, arr) {
        if (val === clotheRecord) {
          return false
        } else {
          return true
        }
      })
      commit(TYPES.DO_REMOVE_CLOTHE_RECORD_FROM_TICKET, records)
    })
  },
  [TYPES.DO_PAY_TICKET]({commit}, playload) {
    return new Promise((resolve, reject) => {
      api.DO_PAY_TICKET(playload.id, playload.fee)
      .then(res => {
        resolve(res)
      })
      .catch(res => {
        reject(res)
      })
    })
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/tickets.js